import './info-rows.scss';

/**
 * version    1.0
 * class      <type> (InfoRows)
 * classdesc  Component that manage InfoRows component
 */
export class InfoRows {
  constructor() {
    this.rows = document.querySelectorAll('.info-rows__row');
    this.activePopover = null;

    this.init();
  }

  init() {
    this.rows.forEach((rows) => {
      const trigger = rows.querySelector('.js-trigger');
      const popover = rows.querySelector('.js-popover-info-rows');
      const closeBtn = rows.querySelector('.js-close');

      // apertura
      if (trigger) {
        trigger.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggle(popover, trigger);
        });

        // chiusura con X
        closeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.close(popover, trigger);
        });
      }
    });

    // click fuori = chiude (backdrop logico)
    document.addEventListener('click', () => {
      this.closeAll();
    });
  }

  toggle(popover, trigger) {
    const isOpen = popover.classList.contains('is-open');

    this.closeAll();

    if (!isOpen) {
      popover.classList.add('is-open');
      popover.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      this.activePopover = popover;
    }
  }

  close(popover, trigger) {
    popover.classList.remove('is-open');
    popover.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    this.activePopover = null;
  }

  closeAll() {
    document.querySelectorAll('.js-popover-info-rows.is-open').forEach((popover) => {
      if (popover) {
        const trigger = popover.closest('.info-rows__row').querySelector('.js-trigger');
        this.close(popover, trigger);
      }
    });
  }
}
